import { SiteModel } from './site.model';
import { SocieteLinkedModel } from './societe-linked.model';

export class Ca1Model extends SocieteLinkedModel {
    // max 30
    signatBc: string;
    // max 30
    signatBp: string;

    idSite: number;

    site: SiteModel;
}
